import { Flex } from '@aloft/toolkit-sui';

import { PropsWithChildren } from 'react';

import { Typography } from '../../../summary/components/Typography.tsx';

export const CommentaryChartContainer = ({
  title,
  children,
}: PropsWithChildren<{ title: string }>) => {
  return (
    <Flex
      flexDirection="column"
      className="commentary-chart-container"
      gap={2}
      width="100%"
      maxWidth="960px"
    >
      <Typography variant="h3">{title}</Typography>
      {children}
    </Flex>
  );
};
